export default __webpack_public_path__ + "static/media/alkahlili_servicecall_manager.6e29ea86.jpg";